/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.userssearch.rpc.AppUsersSearch
 */
import * as References from './AppUsersSearch';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.userssearch.rpc.AppUsersSearch#search
 */
export const SEARCH_QUERY_FIELD_NAME = 'com_hubspot_userssearch_rpc_AppUsersSearch_search';
export const SEARCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_QUERY_FIELD_NAME,
  args: ['searchQuery', 'mustMatchUserIds', 'mustNotMatchUserIds', 'offset', 'onlyConfirmedUsers', 'onlyVisibleUsers', 'onlyHubspotters', 'uniqueUserIds', 'includePartnerUsers', 'includeDeactivatedUsers', 'includeVirtualMamUsers', 'includeAppServiceAccountUsers', 'includeWorkAgentUsers', 'includeHiddenUsers', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.searchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});